import { Drawer, styled } from '@mui/material';

import { generateClasses } from '../../utils/helper';

export const drawerClasses = {
  ...generateClasses('Drawer', ['root', 'paper', 'header', 'body', 'footer']),
};

export const DrawerRoot = styled(Drawer)(({ theme }) => ({
  [`&.${drawerClasses.root}`]: {
    display: 'flex',
    flexDirection: 'column',
  },
  [`& .${drawerClasses.paper}`]: {
    width: 428,
    maxWidth: '100%',
    overflowY: 'unset',
    backgroundColor: theme.palette.background.paper,
  },
  [`& .${drawerClasses.body}`]: {
    flex: 1,
  },
}));

export const Body = styled('div')(({ theme }) => ({
  overflowX: 'hidden',
  overflowY: 'auto',
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
}));

export const Footer = styled('footer')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.grey[800],
  padding: theme.spacing(2),
}));
